module.exports = __webpack_public_path__ + "img/vertical_4_6_5012.292dee35.png";